import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, withModifiers as _withModifiers, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "inhdialog-header" }
const _hoisted_2 = { class: "dialog_name" }
const _hoisted_3 = { class: "dialog_content" }
const _hoisted_4 = {
  key: 0,
  class: "loading-container q-mt-sm"
}
const _hoisted_5 = { class: "field-group__row no-wrap justify-left" }
const _hoisted_6 = {
  key: 1,
  class: "inner_container"
}
const _hoisted_7 = { class: "field-group" }
const _hoisted_8 = { class: "bold-name" }
const _hoisted_9 = {
  class: "row no-wrap",
  ref: "scroll_container",
  style: {"overflow-x":"auto"}
}
const _hoisted_10 = {
  class: "dialog-table",
  ref: "triggerEl"
}
const _hoisted_11 = {
  key: 0,
  class: "field-group"
}
const _hoisted_12 = { class: "bold-name" }
const _hoisted_13 = { class: "field-group" }
const _hoisted_14 = { class: "bold-name" }
const _hoisted_15 = { class: "field-group" }
const _hoisted_16 = { class: "bold-name" }
const _hoisted_17 = { class: "field-group" }
const _hoisted_18 = {
  class: "flex items-end",
  style: {"flex-wrap":"nowrap"}
}
const _hoisted_19 = { class: "bold-name" }
const _hoisted_20 = { class: "field-group" }
const _hoisted_21 = { class: "bold-name flex items-center" }
const _hoisted_22 = { class: "file-button q-ml-sm" }
const _hoisted_23 = { class: "file-list" }
const _hoisted_24 = ["title", "onClick"]
const _hoisted_25 = { class: "pending" }
const _hoisted_26 = {
  key: 1,
  class: "field-group q-my-xs"
}
const _hoisted_27 = { class: "field-group__row" }
const _hoisted_28 = { class: "bold-name" }
const _hoisted_29 = {
  key: 2,
  class: "field-group",
  style: {"width":"100%"}
}
const _hoisted_30 = {
  class: "dialog-table",
  style: {"width":"100%","table-layout":"auto !important"}
}
const _hoisted_31 = { style: {"font-size":"14px"} }
const _hoisted_32 = { style: {"width":"150px"} }
const _hoisted_33 = { class: "row no-wrap items-top" }
const _hoisted_34 = { style: {"display":"flex","flex-direction":"column"} }
const _hoisted_35 = ["innerHTML"]
const _hoisted_36 = { style: {"display":"flex","flex-direction":"column"} }
const _hoisted_37 = { style: {"color":"grey"} }
const _hoisted_38 = {
  key: 0,
  style: {"font-size":"12px","font-weight":"500"}
}
const _hoisted_39 = {
  class: "row no-wrap items-baseline",
  style: {"justify-content":"between"}
}
const _hoisted_40 = {
  key: 0,
  style: {"width":"min-content"}
}
const _hoisted_41 = ["innerHTML"]
const _hoisted_42 = {
  key: 2,
  style: {"width":"min-content"}
}
const _hoisted_43 = {
  key: 0,
  style: {"font-weight":"500"}
}
const _hoisted_44 = {
  key: 0,
  class: "dialog-button"
}
const _hoisted_45 = { class: "row no-wrap justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_icon = _resolveComponent("app-icon")!
  const _component_parameter_inline = _resolveComponent("parameter-inline")!
  const _component_native_input = _resolveComponent("native-input")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_aux_selector = _resolveComponent("aux-selector")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_bill_row = _resolveComponent("bill-row")!
  const _component_project_row = _resolveComponent("project-row")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(), _createBlock(_component_q_card, {
    ref: "cardRootRef",
    class: "inhdialog-container",
    tabindex: "0",
    onKeydown: _withKeys(_withModifiers(_ctx.close, ["prevent"]), ["esc"])
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.isEditMode ? _ctx.$t('information_about')+" " : _ctx.$t('adding')+" ") + _toDisplayString(_ctx.$t('position_genitive')) + _toDisplayString(_ctx.isEditMode ? " " + _ctx.VendorCode : ""), 1),
        _createVNode(_component_app_icon, {
          name: "close",
          width: "18px",
          color: "#979797",
          "hover-color": "#499259",
          cursor: "pointer",
          title: _ctx.$t('close_label'),
          onClick: _ctx.close
        }, null, 8, ["title", "onClick"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.dataLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (n) => {
                return _createElementVNode("div", {
                  key: n,
                  class: "field-group"
                }, [
                  _createElementVNode("div", _hoisted_5, [
                    _cache[11] || (_cache[11] = _createElementVNode("div", { class: "skeleton skeleton-title" }, null, -1)),
                    _createElementVNode("div", {
                      class: _normalizeClass(["skeleton skeleton-text", {
                'skeleton-text-short': n % 3 === 0,
                'skeleton-text-medium': n % 3 === 1,
              }])
                    }, null, 2)
                  ])
                ])
              }), 64))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("name_upcase")), 1),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("table", _hoisted_10, [
                    (_ctx.contextParameterContainerEl)
                      ? (_openBlock(), _createBlock(_component_parameter_inline, {
                          key: 0,
                          "is-root": true,
                          editable: _ctx.CanWrite,
                          "is-table": "",
                          "bold-selected": true,
                          id: 'parameter-dialog',
                          modelValue: _ctx.parameters,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.parameters) = $event)),
                          "token-styles": _ctx.tokenStyles,
                          "show-custom": false,
                          "use-custom-hints": true,
                          "context-trigger": _ctx.contextParameterContainerEl,
                          "create-mode": !_ctx.isEditMode
                        }, null, 8, ["editable", "modelValue", "token-styles", "context-trigger", "create-mode"]))
                      : _createCommentVNode("", true)
                  ], 512)
                ], 512)
              ]),
              (_ctx.positionAddContainer.PriceType === 2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('price_per_unit')), 1),
                    _createVNode(_component_native_input, {
                      ref: 'price_input',
                      style: {"max-width":"245px"},
                      "model-value": _ctx.positionAddContainer.Price,
                      "input-type": "number",
                      "show-border": true,
                      disabledField: !_ctx.CanWrite,
                      "edit-on-click": true,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = 
              (newprice) => {
                _ctx.changeItemPrice(newprice, this.positionAddContainer.PriceType);
                _ctx.positionAddContainer.Price = newprice;
              }
            )
                    }, null, 8, ["model-value", "disabledField"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t("unit_of_measure")), 1),
                _createVNode(_component_q_select, {
                  flat: "",
                  modelValue: _ctx.positionAddContainer.MeasureUnitId,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.positionAddContainer.MeasureUnitId) = $event)),
                  style: {"min-width":"250px"},
                  class: "thin-input q-mr-xs",
                  "dropdown-icon": "expand_more",
                  "fill-input": "",
                  "bottom-slots": false,
                  dense: "",
                  outlined: "",
                  disable: _ctx.isEditMode || !_ctx.CanWrite,
                  "input-debounce": "500",
                  "emit-value": "",
                  "map-options": "",
                  "option-label": "Name",
                  "option-value": "Id",
                  ref: "measure_select",
                  options: 
              _ctx.storage_pos?.measureUnits ? _ctx.storage_pos?.measureUnits.Hints : []
            
                }, null, 8, ["modelValue", "disable", "options"])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t("price_calc_method")), 1),
                _createVNode(_component_q_select, {
                  flat: "",
                  style: {"min-width":"250px"},
                  modelValue: _ctx.currentPriceType,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.currentPriceType) = $event)),
                  class: "thin-input q-mb-xs q-mr-xs",
                  "fill-input": "",
                  "bottom-slots": false,
                  dense: "",
                  outlined: "",
                  disable: !_ctx.CanWrite,
                  "label-slot": false,
                  "hide-bottom-space": "",
                  "dropdown-icon": "expand_more",
                  "option-value": "Id",
                  "option-label": "Name",
                  "input-debounce": "500",
                  ref: 'price_select',
                  options: _ctx.priceOptions,
                  onSelect: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changeItemPrice(_ctx.positionAddContainer.Price)))
                }, null, 8, ["modelValue", "disable", "options"])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('details_type')) + ":", 1),
                  _createElementVNode("span", {
                    class: "comment-tpl-trigger q-ml-sm",
                    style: {"align-self":"start"},
                    onClick: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"]))
                  }, [
                    _createVNode(_component_app_icon, {
                      name: "comment-template",
                      width: "18px",
                      color: _ctx.CanWrite ? '#979797' : '#c9c9c9',
                      "hover-color": _ctx.CanWrite ? '#499259' : '#c9c9c9',
                      cursor: _ctx.CanWrite ? 'pointer' : 'default',
                      title: _ctx.$t('info_templates')
                    }, null, 8, ["color", "hover-color", "cursor", "title"]),
                    (_ctx.CanWrite)
                      ? (_openBlock(), _createBlock(_component_q_menu, {
                          key: 0,
                          "max-height": "1300px",
                          ref: "comment_template_menu",
                          anchor: "center right",
                          self: "center left"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_aux_selector, {
                              "model-type": 24,
                              "input-index": 0,
                              "allow-multiple": false,
                              "allow-free-input": true,
                              onDeleteItem: _ctx.deleteCommentTemplate,
                              modelValue: _ctx.comment_templates,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.comment_templates) = $event)),
                              onInputValue: _cache[6] || (_cache[6] = 
                    (val) => {
                      _ctx.addCommentTemplate(val);
                    }
                  ),
                              onSelectorClosed: _cache[7] || (_cache[7] = ($event: any) => (
                    _ctx.$refs.comment_template_menu &&
                      _ctx.$refs.comment_template_menu.hide()
                  ))
                            }, null, 8, ["onDeleteItem", "modelValue"])
                          ]),
                          _: 1
                        }, 512))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode(_component_native_input, {
                  ref: "comment_field",
                  style: {"width":"-webkit-fill-available"},
                  "show-border": true,
                  disabledField: !_ctx.CanWrite,
                  "model-value": _ctx.positionAddContainer.Details,
                  "onUpdate:caretPosition": _ctx.onCaretPositionChange,
                  onClick: _ctx.onNativeInputClick,
                  onBlur: _ctx.onCommentBlur,
                  "edit-on-click": true,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = 
              (newname) => {
                _ctx.changeItemNote(newname);
              }
            )
                }, null, 8, ["disabledField", "model-value", "onUpdate:caretPosition", "onClick", "onBlur"])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createTextVNode(_toDisplayString(_ctx.$t("files")) + " ", 1),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("input", {
                      ref: "fileInputStorage",
                      type: "file",
                      multiple: "",
                      hidden: "",
                      onChange: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.attachFileForPositionAdd && _ctx.attachFileForPositionAdd(...args)))
                    }, null, 544),
                    _createVNode(_component_q_icon, {
                      name: _ctx.fileIconName,
                      size: "xs",
                      disable: !_ctx.CanWrite,
                      color: "accent",
                      class: "pointer hover-green",
                      title: _ctx.$t('attach_files'),
                      onClick: _ctx.chooseAndUploadFile
                    }, null, 8, ["name", "disable", "title", "onClick"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.attachedFiles, (file, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "file-item"
                    }, [
                      _createElementVNode("span", {
                        class: "file_container",
                        title: _ctx.$t('upload_file'),
                        onClick: _withModifiers(($event: any) => (_ctx.DownloadFile(file, $event)), ["stop"])
                      }, _toDisplayString(file.Name), 9, _hoisted_24),
                      (_ctx.CanWrite)
                        ? (_openBlock(), _createBlock(_component_app_icon, {
                            key: 0,
                            name: "delete-outline",
                            width: "18px",
                            color: "#979797",
                            "hover-color": "#499259",
                            cursor: "pointer",
                            title: _ctx.$t('remove'),
                            onClick: ($event: any) => (_ctx.deleFileFromPositionAdd(file.Id))
                          }, null, 8, ["title", "onClick"]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pendingFiles, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.tempId,
                      class: "file-item"
                    }, [
                      _createElementVNode("span", _hoisted_25, _toDisplayString(item.name) + " (" + _toDisplayString(_ctx.$t('prepared')) + ") ", 1),
                      (_ctx.CanWrite)
                        ? (_openBlock(), _createBlock(_component_app_icon, {
                            key: 0,
                            name: "delete-outline",
                            width: "18px",
                            color: "#979797",
                            "hover-color": "#499259",
                            cursor: "pointer",
                            title: _ctx.$t('remove'),
                            onClick: ($event: any) => (_ctx.removePending(item.tempId))
                          }, null, 8, ["title", "onClick"]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ])
              ]),
              (_ctx.isEditMode)
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.$t("amount_by_positions")) + ":", 1),
                      _createElementVNode("span", null, _toDisplayString(_ctx.money(_ctx.currentTotalAmount)), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.currentMovements && _ctx.currentMovements.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                    _createElementVNode("table", _hoisted_30, [
                      _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", null, _toDisplayString(_ctx.$t('sku')), 1),
                          _createElementVNode("th", null, _toDisplayString(_ctx.$t('date_label')), 1),
                          _createElementVNode("th", null, _toDisplayString(_ctx.$t('from')) + "/" + _toDisplayString(_ctx.$t('to_upper')), 1),
                          _createElementVNode("th", null, _toDisplayString(_ctx.$t('responsible_worker')), 1),
                          _createElementVNode("th", null, [
                            _createTextVNode(_toDisplayString(_ctx.$t('quantity_short')), 1),
                            _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1)),
                            _createTextVNode(_toDisplayString(_ctx.$t('price_per_unit_short')), 1),
                            _cache[13] || (_cache[13] = _createElementVNode("br", null, null, -1)),
                            _createTextVNode(_toDisplayString(_ctx.$t('total_label')), 1)
                          ]),
                          _createElementVNode("th", null, _toDisplayString(_ctx.$t('bills')) + "/" + _toDisplayString(_ctx.$t('projects_lower')), 1),
                          _createElementVNode("th", null, _toDisplayString(_ctx.$t('details_type')), 1)
                        ])
                      ]),
                      _createElementVNode("tbody", _hoisted_31, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentMovements, (row_move, idx) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: 'conn_line_' + idx
                          }, [
                            _createElementVNode("td", _hoisted_32, [
                              _createElementVNode("div", _hoisted_33, [
                                _createElementVNode("div", _hoisted_34, [
                                  (row_move.Id)
                                    ? (_openBlock(), _createBlock(_component_app_icon, {
                                        key: 0,
                                        class: "item-move-info q-mx-xs",
                                        name: "info-circle-outline",
                                        width: "18px",
                                        color: "#979797",
                                        "hover-color": "#499259",
                                        cursor: "pointer",
                                        title: _ctx.$t('info'),
                                        onClick: ($event: any) => (
                          _ctx.openInfoDialog(row_move.Id, row_move.MovementType)
                        )
                                      }, null, 8, ["title", "onClick"]))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("span", {
                                    innerHTML: _ctx.moveTypeName(row_move.MovementType),
                                    style: {"margin-left":"8px"}
                                  }, null, 8, _hoisted_35)
                                ]),
                                _createElementVNode("div", _hoisted_36, [
                                  _createElementVNode("span", _hoisted_37, _toDisplayString(row_move.VendorCode), 1),
                                  (row_move.ItemsInMovementCount > 1)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(_ctx.$t("total")) + " " + _toDisplayString(row_move.ItemsInMovementCount) + " " + _toDisplayString(_ctx.$t("pos_abbr")), 1))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.dateFormatted(row_move.Date)), 1)
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("div", _hoisted_39, [
                                (!_ctx.isIncome(row_move.MovementType))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_40, _toDisplayString(row_move.SourceStorage?.Name), 1))
                                  : _createCommentVNode("", true),
                                (_ctx.isTransfer(row_move.MovementType))
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 1,
                                      style: {"margin-left":"3px"},
                                      innerHTML: _ctx.moveTypeName(row_move.MovementType)
                                    }, null, 8, _hoisted_41))
                                  : _createCommentVNode("", true),
                                (!_ctx.isExpense(row_move.MovementType))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_42, _toDisplayString(row_move.ReceiverStorage?.Name), 1))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("span", null, _toDisplayString(row_move.Creator?.Name), 1)
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("span", null, _toDisplayString(row_move.ItemQuantity), 1),
                              _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1)),
                              _createElementVNode("span", null, _toDisplayString(row_move.SingleItemPrice), 1),
                              _cache[15] || (_cache[15] = _createElementVNode("br", null, null, -1)),
                              _createElementVNode("span", null, _toDisplayString(row_move.TotalAmount), 1)
                            ]),
                            _createElementVNode("td", null, [
                              (row_move.Bills.length)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_43, _toDisplayString(_ctx.$t("bills")) + ": ", 1))
                                : _createCommentVNode("", true),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row_move.Bills, (bill, bi) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: 'imb-' + bi
                                }, [
                                  _createVNode(_component_bill_row, {
                                    el: bill,
                                    "bill-type": 1
                                  }, null, 8, ["el"])
                                ]))
                              }), 128)),
                              (row_move.Projects.length)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 1,
                                    style: _normalizeStyle(
                      'font-weight: 500;' +
                      (row_move.Bills.length ? 'margin-top: 8px;' : '')
                    )
                                  }, _toDisplayString(_ctx.$t("projects_label")) + ": ", 5))
                                : _createCommentVNode("", true),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row_move.Projects, (project, pi) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: 'imp-' + pi
                                }, [
                                  _createVNode(_component_project_row, {
                                    class: "q-mb-xs",
                                    el: project,
                                    "hide-remove-btn": true
                                  }, null, 8, ["el"])
                                ]))
                              }), 128))
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("span", null, _toDisplayString(row_move.Details), 1)
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
      ]),
      (!_ctx.isEditMode)
        ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
            _createElementVNode("div", _hoisted_45, [
              _createVNode(_component_q_btn, {
                "no-caps": "",
                label: _ctx.isLoading ? _ctx.$t('loading_short') : _ctx.$t('save'),
                color: "primary",
                onClick: _ctx.AddPosition,
                disable: !_ctx.creationAllowed || _ctx.isLoading || !_ctx.CanWrite
              }, null, 8, ["label", "onClick", "disable"]),
              _createVNode(_component_q_btn, {
                label: _ctx.$t('cancel_short'),
                "no-caps": "",
                flat: "",
                onClick: _ctx.close
              }, null, 8, ["label", "onClick"])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["onKeydown"]))
}